<div class="modal-body" [class.ins-border-bottom]="bottomBorder">
  <div class="content" [class.content-padding]="!noPadding"><ng-content></ng-content></div>
</div>
